import { render } from "./HighlightSection.vue?vue&type=template&id=3ad2f142&scoped=true"
import script from "./HighlightSection.vue?vue&type=script&lang=js"
export * from "./HighlightSection.vue?vue&type=script&lang=js"

import "./HighlightSection.vue?vue&type=style&index=0&id=3ad2f142&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad2f142"]])

export default __exports__